import { render, staticRenderFns } from "./page-sub-header.vue?vue&type=template&id=0d223c57&"
import script from "./page-sub-header.vue?vue&type=script&lang=js&"
export * from "./page-sub-header.vue?vue&type=script&lang=js&"
import style0 from "./page-sub-header.vue?vue&type=style&index=0&id=0d223c57&prod&module=true&lang=scss&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
